// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/samkalp-faculty/SamkalpFacultyDashboard.css
 * All rules scoped under .samkalp-faculty-shell to avoid any collision
 * with existing global/Bootstrap classes site-wide (same convention as
 * SamkalpAdminDashboard.css / AskosDashboard.css).
 */
.samkalp-faculty-shell {
    display: flex;
    min-height: 100vh;
    background: #f7f9fc;
    font-family: inherit;
}

.samkalp-faculty-sidebar {
    width: 240px;
    flex-shrink: 0;
    background: #092957;
    color: #fff;
    display: flex;
    flex-direction: column;
    padding: 22px 0;
    position: sticky;
    top: 0;
    height: 100vh;
}

.samkalp-faculty-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 20px 20px;
    border-bottom: 1px solid rgba(255,255,255,0.15);
    margin-bottom: 10px;
}

.samkalp-faculty-brand-sun {
    font-size: 22px;
    color: #f1a51c;
}

.samkalp-faculty-brand strong {
    display: block;
    font-size: 1rem;
    letter-spacing: 0.03em;
}

.samkalp-faculty-brand span {
    display: block;
    color: #f1a51c;
    font-weight: 700;
    font-size: 0.72rem;
}

.samkalp-faculty-nav {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    padding: 8px 12px;
    gap: 4px;
}

.samkalp-faculty-nav-link {
    display: block;
    padding: 10px 14px;
    border-radius: 8px;
    color: rgba(255,255,255,0.8);
    text-decoration: none;
    font-size: 0.9rem;
    background: transparent;
    border: none;
    text-align: left;
    width: 100%;
}

.samkalp-faculty-nav-link:hover {
    background: rgba(255,255,255,0.08);
    color: #fff;
}

.samkalp-faculty-nav-link.active {
    background: #f1a51c;
    color: #092957;
    font-weight: 700;
}

.samkalp-faculty-nav-external {
    color: #9fd6ff;
}

.samkalp-faculty-sidebar-footer {
    padding: 16px 20px 0;
    border-top: 1px solid rgba(255,255,255,0.15);
}

.samkalp-faculty-slug {
    font-size: 0.75rem;
    color: rgba(255,255,255,0.5);
    margin-bottom: 10px;
}

.samkalp-faculty-logout-btn {
    background: transparent;
    border: 1px solid rgba(255,255,255,0.3);
    color: #fff;
    border-radius: 8px;
    padding: 6px 14px;
    font-size: 0.85rem;
}

.samkalp-faculty-main {
    flex: 1 1;
    padding: 28px 32px;
    overflow-y: auto;
}

.schedule-submit-btn {
    background: #092957;
    border: none;
    font-weight: 700;
    padding: 10px 24px;
}

.session-row .card-body:hover {
    background: #fafbff;
}

@media (max-width: 900px) {
    .samkalp-faculty-shell { display: block; }
    .samkalp-faculty-sidebar {
        position: static;
        width: 100%;
        height: auto;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        padding: 14px 16px;
    }
    .samkalp-faculty-brand { border-bottom: none; margin-bottom: 0; padding: 0; }
    .samkalp-faculty-nav { flex-direction: row; flex-wrap: wrap; padding: 0; }
    .samkalp-faculty-nav-link { width: auto; }
    .samkalp-faculty-sidebar-footer { border-top: none; padding: 0; margin-left: auto; display: flex; align-items: center; gap: 10px; }
    .samkalp-faculty-slug { margin-bottom: 0; }
    .samkalp-faculty-main { padding: 20px 16px; }
}
`, "",{"version":3,"sources":["webpack://./src/samkalp-faculty/SamkalpFacultyDashboard.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,qBAAqB;IACrB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,uCAAuC;IACvC,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB,cAAc,EAAE;IACzC;QACI,gBAAgB;QAChB,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,mBAAmB;QACnB,kBAAkB;IACtB;IACA,yBAAyB,mBAAmB,EAAE,gBAAgB,EAAE,UAAU,EAAE;IAC5E,uBAAuB,mBAAmB,EAAE,eAAe,EAAE,UAAU,EAAE;IACzE,4BAA4B,WAAW,EAAE;IACzC,kCAAkC,gBAAgB,EAAE,UAAU,EAAE,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;IAClI,wBAAwB,gBAAgB,EAAE;IAC1C,wBAAwB,kBAAkB,EAAE;AAChD","sourcesContent":["/* frontend/src/samkalp-faculty/SamkalpFacultyDashboard.css\n * All rules scoped under .samkalp-faculty-shell to avoid any collision\n * with existing global/Bootstrap classes site-wide (same convention as\n * SamkalpAdminDashboard.css / AskosDashboard.css).\n */\n.samkalp-faculty-shell {\n    display: flex;\n    min-height: 100vh;\n    background: #f7f9fc;\n    font-family: inherit;\n}\n\n.samkalp-faculty-sidebar {\n    width: 240px;\n    flex-shrink: 0;\n    background: #092957;\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    padding: 22px 0;\n    position: sticky;\n    top: 0;\n    height: 100vh;\n}\n\n.samkalp-faculty-brand {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 0 20px 20px;\n    border-bottom: 1px solid rgba(255,255,255,0.15);\n    margin-bottom: 10px;\n}\n\n.samkalp-faculty-brand-sun {\n    font-size: 22px;\n    color: #f1a51c;\n}\n\n.samkalp-faculty-brand strong {\n    display: block;\n    font-size: 1rem;\n    letter-spacing: 0.03em;\n}\n\n.samkalp-faculty-brand span {\n    display: block;\n    color: #f1a51c;\n    font-weight: 700;\n    font-size: 0.72rem;\n}\n\n.samkalp-faculty-nav {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 8px 12px;\n    gap: 4px;\n}\n\n.samkalp-faculty-nav-link {\n    display: block;\n    padding: 10px 14px;\n    border-radius: 8px;\n    color: rgba(255,255,255,0.8);\n    text-decoration: none;\n    font-size: 0.9rem;\n    background: transparent;\n    border: none;\n    text-align: left;\n    width: 100%;\n}\n\n.samkalp-faculty-nav-link:hover {\n    background: rgba(255,255,255,0.08);\n    color: #fff;\n}\n\n.samkalp-faculty-nav-link.active {\n    background: #f1a51c;\n    color: #092957;\n    font-weight: 700;\n}\n\n.samkalp-faculty-nav-external {\n    color: #9fd6ff;\n}\n\n.samkalp-faculty-sidebar-footer {\n    padding: 16px 20px 0;\n    border-top: 1px solid rgba(255,255,255,0.15);\n}\n\n.samkalp-faculty-slug {\n    font-size: 0.75rem;\n    color: rgba(255,255,255,0.5);\n    margin-bottom: 10px;\n}\n\n.samkalp-faculty-logout-btn {\n    background: transparent;\n    border: 1px solid rgba(255,255,255,0.3);\n    color: #fff;\n    border-radius: 8px;\n    padding: 6px 14px;\n    font-size: 0.85rem;\n}\n\n.samkalp-faculty-main {\n    flex: 1;\n    padding: 28px 32px;\n    overflow-y: auto;\n}\n\n.schedule-submit-btn {\n    background: #092957;\n    border: none;\n    font-weight: 700;\n    padding: 10px 24px;\n}\n\n.session-row .card-body:hover {\n    background: #fafbff;\n}\n\n@media (max-width: 900px) {\n    .samkalp-faculty-shell { display: block; }\n    .samkalp-faculty-sidebar {\n        position: static;\n        width: 100%;\n        height: auto;\n        flex-direction: row;\n        flex-wrap: wrap;\n        align-items: center;\n        padding: 14px 16px;\n    }\n    .samkalp-faculty-brand { border-bottom: none; margin-bottom: 0; padding: 0; }\n    .samkalp-faculty-nav { flex-direction: row; flex-wrap: wrap; padding: 0; }\n    .samkalp-faculty-nav-link { width: auto; }\n    .samkalp-faculty-sidebar-footer { border-top: none; padding: 0; margin-left: auto; display: flex; align-items: center; gap: 10px; }\n    .samkalp-faculty-slug { margin-bottom: 0; }\n    .samkalp-faculty-main { padding: 20px 16px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
